import { createAction, props } from '@ngrx/store';
import { Team } from '@app/shared/models/team';
import { Domain } from '@app/shared/models/domain';
import { CreateDomainOutput } from '@smash-sdk/domain/01-2024';

// Update domain from form
export const updateDomainToCreate = createAction(
  '[Domain Signup] Update Domain To Create',
  props<{ domain: string }>()
);

// Get Domains
export const loadDomains = createAction(
  '[Domain Signup] Load Domains'
);

export const loadDomainsSuccess = createAction(
  '[Domain Signup] Load Domains Success'
);

export const loadDomainsFailure = createAction(
  '[Domain Signup] Load Domains Failure'
);

// Create domain
export const createDomain = createAction(
  '[Domain Signup] Create Domain',
);

export const createDomainSuccess = createAction(
  '[Domain Signup] Create Domain Success',
  props<{ domain: CreateDomainOutput['domain'], teams?: Team[], selectedTeam?: Team }>()
);

export const createDomainFailure = createAction(
  '[Domain Signup] Create Domain Failure',
  props<{ error: any }>()
);

export const InitiateTeam = createAction(
  '[Domain Signup] Initiate Team',
  props<{ domain: any, team?: string }>()
);

export const InitiateTeamSuccess = createAction(
  '[Domain Signup] Initiate Team Success',
  props<{ team: Team }>()
);

export const InitiateTeamFailure = createAction(
  '[Domain Signup] Initiate Team Failure',
  props<{ error: string }>()
);
